import CoachingPreferences from './components/CoachingPreferences/';
import Spinner from '../../../../../../components/Spinner/';

import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

const CoachingPreferencesData = gql`
query {
  viewer {
    advisor_info {
      typical_monthly_availability
    }
    
    topics {
      id
      name
    }
  }
  
  TopicCategories {
    id
    name
    topics {
      id
      name
    }
  }
}
`;

const SubmitData = gql`
mutation SubmitCoachingPreferenceData(
  $TopicIDs: [Int]
  $MonthlyAvailable: Int
){
  setUserTopics(
    topics: $TopicIDs
  ) {
    id
  }
  
  updateUser(input:{
    typical_monthly_availability: $MonthlyAvailable
  }) {
    id
  }
}
`;

export default (store) => ({
  path: 'coachingpreferences',
  component: compose(
    graphql(CoachingPreferencesData, {
      name: 'CoachingPreferencesData',
      options: props => {
        return ({
          variables: {
            UserID: props.authedUserID || store.getState().auth.sub,
          },
          fetchPolicy: 'network-only'
        });
      },
    }),
    graphql(SubmitData, {
      name: 'SubmitData',
    })
  )((props) => {
    if (props.CoachingPreferencesData.loading === false) {
      return <CoachingPreferences {...props} />;
    }
    return <Spinner />;
  }),
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/CoachingPreferences/index.js